import { Button, Component, Enum, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';
import { FeatureActivityEventName } from '../../../Data/Config/FeatureActivityConfig';

const { ccclass, property, requireComponent } = _decorator;

@ccclass('ActivityButton')
@requireComponent(Button)
export default class ActivityButton extends Component {
    @property({ type: Enum(FeatureActivityEventName) })
    private readonly eventName: FeatureActivityEventName = FeatureActivityEventName.ClickFreePlay;

    protected onLoad() {
        this.node.on(Button.EventType.CLICK, this._onClick, this);
    }

    private _onClick() {
        Lobby.activity.send(this.eventName, {});
    }
}
